import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';

import {
  bundledEntityColorPalette,
  parseEntityColorPalette,
  type EntityColorPalette,
} from './entityColorPalette';

const EntityColorPaletteContext = createContext<EntityColorPalette>(bundledEntityColorPalette);
let remotePaletteRequest: Promise<EntityColorPalette> | undefined;

function loadRemotePalette() {
  remotePaletteRequest ??= fetch('/api/v1/ui/entity-color-palette', {
    credentials: 'omit',
    cache: 'no-store',
    headers: { Accept: 'application/json' },
  }).then(async response => {
    if (!response.ok) throw new Error('Palette request failed');
    const body = await response.json() as {data?: unknown};
    return parseEntityColorPalette(body.data);
  });
  return remotePaletteRequest;
}

export function EntityColorPaletteProvider({ children }: {children: ReactNode}) {
  const [palette, setPalette] = useState(bundledEntityColorPalette);

  useEffect(() => {
    let stopped = false;
    void loadRemotePalette()
      .then(next => {
        if (!stopped) setPalette(next);
      })
      .catch(() => undefined);
    return () => {
      stopped = true;
    };
  }, []);

  return <EntityColorPaletteContext.Provider value={palette}>{children}</EntityColorPaletteContext.Provider>;
}

export function useEntityColorPalette() {
  return useContext(EntityColorPaletteContext);
}
